import cn from "classnames";
import { Transition } from "components/shared/column";
import { Checkbox, Field } from "components/shared/form";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import React, { useEffect, useState } from "react";
import { Link, NavLink, Redirect, Route, Switch } from "react-router-dom";
import {
    checkRussianPostConnection,
    editParcelProviderSettings,
    getParcelProviderSettings,
} from "sources/profile/organization";
import Cdek from "./cdek";
import RussianPost from "./russianPost";

const config = {
    russianPost: {
        login: {
            label: "Логин",
            inputProps: { name: "login" },
        },
        password: {
            label: "Пароль",
            inputProps: { name: "password", type: "password" },
        },
        hasContract: {
            label: "Есть договор, чтобы пользоваться интеграцией без ограничений",
            inputProps: { name: "hasContract" },
            type: "checkbox",
            fieldBeforeLabel: true,
            labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
            fieldWrapper: "col-auto pr-1 pl-0",
            bWrapper: "d-flex align-items-center mb-3",
        },
    },
    cdek: {
        login: {
            label: "Логин",
            inputProps: { name: "login" },
        },
        password: {
            label: "Пароль",
            inputProps: { name: "password", type: "password" },
        },
    },
};

export default function ParcelIntegration(props) {
    const [loading, setLoading] = useState(true);
    const [checkingRussianPostConnection, setCheckingRussianPostConnection] = useState(false);
    const [data, setData] = useState({ russianPost: undefined, cdek: undefined });

    useEffect(() => {
        getParcelProviderSettings().then((response) => {
            if (response) {
                setData(response);
            }
            setLoading(false);
        });
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        ymEvent(props.location.pathname.includes("russian-post") ? "SaveMailintegration" : "SaveSDEKIntegration");
        setLoading(true);
        editParcelProviderSettings(data).then(() => setLoading(false));
    };

    const handleDelete = (provider) => {
        setLoading(true);
        const newData = { ...data, [provider]: undefined };
        setData(newData);
        editParcelProviderSettings(newData).then(() => setLoading(false));
    };

    const handleCheckRussianPostConnection = () => {
        setLoading(true);
        setCheckingRussianPostConnection(true);
        checkRussianPostConnection()
            .catch(() => undefined)
            .finally(() => {
                setCheckingRussianPostConnection(false);
                setLoading(false);
            });
    };

    const setValue = (prefix, { name, value }) =>
        setData({ ...data, [prefix]: { ...(data[prefix] ?? {}), [name]: value } });

    const renderField = (prefix, name) => (
        <Field
            {...config[prefix][name]}
            required
            validators={[requiredField]}
            labelWrapper="col-sm-3 col-md-2 col-form-label col-form-label-sm text-left"
            fieldWrapper="col-sm-6 col-md-4"
            value={data[prefix]?.[name] ?? ""}
            onChange={(params) => setValue(prefix, params)}
        />
    );

    const renderCheckbox = (prefix, name) => (
        <Checkbox
            {...config[prefix][name]}
            value={data[prefix]?.[name] ?? false}
            onChange={(params) => setValue(prefix, params)}
        />
    );

    const componentProps = (prefix) => ({
        renderField,
        renderCheckbox,
        handleSubmit,
        handleCheckRussianPostConnection,
        handleDelete: () => handleDelete(prefix),
        checkingRussianPostConnection,
        canDelete: Boolean(data[prefix]),
        disabled: !data[prefix] || Object.values(data[prefix] ?? {}).some((item) => String(item).length === 0),
    });

    return (
        <Transition dir="right">
            <div className="page-book__show book-show">
                <div className="book-show__head">
                    <Link className="book-show__close close close--sm" to={paths.integration} />
                    <div className="book-show__title">Документооборот (Почта России, СДЭК)</div>
                </div>
                <div className={cn("book-show__body", { loading })}>
                    <div className="d-flex flex-column h-100">
                        <div className="container-fluid mb-3">
                            <ul className="profile__menu profile-menu no-bullet">
                                <li className="profile-menu__item">
                                    <NavLink
                                        to={`${paths.integrationItem("parcel")}/russian-post`}
                                        className="profile-menu__link"
                                        activeClassName="profile-menu__link--active"
                                    >
                                        Почта России
                                    </NavLink>
                                </li>
                                <li className="profile-menu__item">
                                    <NavLink
                                        to={`${paths.integrationItem("parcel")}/cdek`}
                                        className="profile-menu__link"
                                        activeClassName="profile-menu__link--active"
                                    >
                                        СДЭК
                                    </NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="flex-grow-1 overflow-hidden">
                            <Switch>
                                <Route
                                    path={`${paths.integrationItem("parcel")}/russian-post`}
                                    render={(rest) => <RussianPost {...rest} {...componentProps("russianPost")} />}
                                />
                                <Route
                                    path={`${paths.integrationItem("parcel")}/cdek`}
                                    render={(rest) => <Cdek {...rest} {...componentProps("cdek")} />}
                                />
                                <Route
                                    exact
                                    path={paths.integrationItem("parcel")}
                                    render={() => <Redirect to={`${paths.integrationItem("parcel")}/russian-post`} />}
                                />
                            </Switch>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    );
}
